import { Injectable } from '@angular/core';
import { DataTableRequest } from '../../models/datatable-request';
import { UserList } from '../../models/user-list';
import { Observable } from 'rxjs';
import { HttpParams, HttpClient } from '@angular/common/http';
import { CommonConfig } from 'src/app/constants/common-config';
import { RoleList } from '../../models/role-list';
import { User } from '../../models/user';
import { ChangePasswordRequest } from '../../models/change-password-request';
import { Users } from '../../models/users';
import { GeneralResponse } from '../../models/general-response';
import { UserHierarchyList } from '../../models/user-hierarchy-list';
import { UserHierarchy } from '../../models/user-hierarchy';
import { environment } from 'src/environments/environment';
import { Dashboard } from '../../models/dashboard.t';
import { SaldoCutiRequest } from 'src/app/models/saldo-cuti-request';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  path = '/user';
  constructor(private http: HttpClient) { }

  getUser(userId: string): Observable<User> {
    return this.http.get<User>(environment.apiUrl + '/user/' + userId);
  }

  getUsers(payload: DataTableRequest): Observable<UserList> {
    const params = new HttpParams().append('searchTerm', payload.searchTerm);

    return this.http.get<UserList>(
      environment.apiUrl +
      '/user/list/' +
      payload.page +
      '/' +
      payload.dataPerPage,
      {
        ...CommonConfig.HTTP_OPTIONS,
        params: params,
      }
    );
  }

  getAlarmUsers(payload: DataTableRequest): Observable<UserList> {
    const params = new HttpParams().append('searchTerm', payload.searchTerm);

    return this.http.get<UserList>(
      `${environment.apiUrl}/user/list-alarm/${payload.typeId}/${payload.page}/${payload.dataPerPage}`,
      {
        ...CommonConfig.HTTP_OPTIONS,
        params: params,
      }
    );
  }

  getByRole(role: number): Observable<Users> {
    return this.http.get<Users>(
      `${environment.apiUrl}/user/list-per-role/${role}`,
      {
        ...CommonConfig.HTTP_OPTIONS,
      }
    );
  }

  getRoles(): Observable<RoleList> {
    return this.http.get<RoleList>(environment.apiUrl + '/user/roles');
  }

  save(user: User): Observable<any> {
    return this.http.put(environment.apiUrl + '/user/add', user, {
      ...CommonConfig.HTTP_OPTIONS,
    });
  }

  update(user: User): Observable<any> {
    return this.http.post(environment.apiUrl + '/user/update', user, {
      ...CommonConfig.HTTP_OPTIONS,
    });
  }

  delete(user: User): Observable<any> {
    return this.http.delete(environment.apiUrl + '/user/delete/' + user.id);
  }

  changePassword(request: ChangePasswordRequest): Observable<any> {
    return this.http.post(
      environment.apiUrl + '/user/change-password',
      request,
      {
        ...CommonConfig.HTTP_OPTIONS,
      }
    );
  }

  reset(userId: string | undefined): Observable<any> {
    return this.http.post(
      environment.apiUrl + '/user/reset-default-password?userId=' + userId,
      {
        ...CommonConfig.HTTP_OPTIONS,
      }
    );
  }

  refine(): Observable<any> {
    return this.http.post(environment.apiUrl + '/user/refine', {
      ...CommonConfig.HTTP_OPTIONS,
    });
  }

  checkToken(): Observable<GeneralResponse> {
    return this.http.get<GeneralResponse>(
      environment.apiUrl + '/user/check-token'
    );
  }

  getHierarchyList(userId: string | undefined): Observable<UserHierarchyList> {
    return this.http.get<UserHierarchyList>(
      `${environment.apiUrl}/user/hierarchy/list/${userId}`
    );
  }

  addHierarchy(userHierarchy: UserHierarchy): Observable<UserHierarchy> {
    return this.http.put<UserHierarchy>(
      `${environment.apiUrl}/user/hierarchy/add`,
      userHierarchy,
      {
        ...CommonConfig.HTTP_OPTIONS,
      }
    );
  }

  deleteHierarchy(userHierarchy: UserHierarchy): Observable<any> {
    return this.http.delete(
      `${environment.apiUrl}/user/hierarchy/delete/${userHierarchy.id}`
    );
  }

  upload(
    files: File[],
  ): Observable<GeneralResponse> {
    const formData: FormData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append('file', files[i]);
    }

    return this.http.post<GeneralResponse>(
      `${environment.apiUrl}/user/upload/`,
      formData,
    );
  }

  upload2(
    files: File[],
  ): Observable<GeneralResponse> {
    const formData: FormData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append('file', files[i]);
    }

    return this.http.post<GeneralResponse>(
      `${environment.apiUrl}/user/upload-riwayat/`,
      formData,
    );
  }

  dashboard(userId: string): Observable<Dashboard> {
    return this.http.get<Dashboard>(`${environment.apiUrl}${this.path}/dashboard/${userId}`, {
      ...CommonConfig.HTTP_OPTIONS,
    });
  }

  updateHakCuti(saldoCutiRequest: SaldoCutiRequest): Observable<GeneralResponse> {
    return this.http.post<GeneralResponse>(
      `${environment.apiUrl}/user/update-hak-cuti`, saldoCutiRequest,
    );
  }
}
